<template>
  <LayoutOneColumn :loading="loading" show-right-sidebar-on-mobile>
    <div>
      <div class="flex sm:gap-x-2 mb-4 px-4 lg:py-1 sm:px-2 flex-wrap gap-1">
        <SidebarMenuItem
          v-for="section in sorts"
          :key="section.id"
          :item="section"
          theme="white"
        />
        <TopbarMenu :menu-list="topbarMenu" class="!mb-0" />
      </div>

      <NuxtPage />
    </div>
  </LayoutOneColumn>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { ComputedRef } from 'vue'
import { useNavigation } from '~/stores/navigation'
import type { TopbarMenuInterface } from '~/models/menu'
import { NavigationSortType } from '~/models/navigation'

const { t } = useI18n()
const { getSortItems, getCategoryItems, fetchCategories } = useNavigation()
const navStore = useNavigation()
const loading = ref(!navStore.categoriesList.length)

onBeforeMount(async () => {
  await fetchCategories()
  loading.value = false
})

onServerPrefetch(async () => {
  await fetchCategories()
  loading.value = false
})

const sorts = getSortItems('news', [
  NavigationSortType.Premium,
  NavigationSortType.All,
  // NavigationSortType.Popular,
  // NavigationSortType.New,
])

const categories = getCategoryItems('news')

const topbarMenu: ComputedRef<TopbarMenuInterface[]> = computed(() => [
  /* {
    title: t('menu.all_news'),
    items: sorts.value,
    style: 'col',
  }, */
  {
    title: t('common.categories'),
    items: categories.value,
    style: 'row',
  },
])
</script>
